import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import md5 from 'md5';
import { fetchSkuListSearch } from 'b2b-apps/shop/catalog/redux/skuList/actionCreators';
import { getSkusFromQuery } from 'b2b-apps/shop/catalog/redux/skuList/selectors';
import { State } from 'b2b-apps/shop/common/redux/types';
import { ProductGroupType, SOURCE_TYPE } from 'b2b-apps/shop/content/common';

const useProductsFromQuery = (product: ProductGroupType): string[] => {
  const {
    source_type: sourceType,
    source_of_products: query,
  } = product;
  const parsedQuery = query?.substring(query.indexOf('?'));
  const dispatch = useDispatch();
  const queryId = md5(parsedQuery.toLowerCase());
  const content = useSelector(
    useCallback(
      (state: State) => getSkusFromQuery(state, queryId),
      [queryId],
    ),
  );

  useEffect((): void => {
    if (sourceType === SOURCE_TYPE.query) {
      dispatch(fetchSkuListSearch(parsedQuery));
    }
  }, [dispatch, parsedQuery, sourceType]);

  return content;
};

export {
  useProductsFromQuery,
};
